<div *ngIf="isVisible" class="loading-modal-overlay">
  <div class="loading-modal-content">
    <div class="loading-spinner"></div>
    <p>Carregando...</p>
  </div>
</div>